import analytics from 'js/services/Analytics';
import AnonymousId from 'js/services/AnonymousId';
import { castEventToValue } from 'js/services/FormTools';
import { errorResponse, makeRequest, navigate, url } from 'js/services/Network';
import AppState from "js/stores/AppState";
import SteppedPage from 'js/stores/SteppedPage';
import { pick } from 'lodash';
import { castToSnapshot, flow, types } from 'mobx-state-tree';
import img from '../../../../public/images/new-upload.png';
import Address from '../types/Address';

const CreateNewPaymentLinkPageState = types
  .model('CreateNewPaymentLinkPage', {
    isSubmitting: false,
    modalIsVisible: false,
    error: types.maybeNull(types.string),
    anonymous_id: AnonymousId,

    isHoveringFiles: false,
    isUploadingFiles: false,
    uploadFilesError: '',
    requestInProgress: false,

    hasEnteredTitle: false,
    hasEnteredPrice: false,
    hasEnteredQuantity: false,
    hasSelectedSize: false,
    hasEnteredAddress: false,

    primary_image: img,
    primary_image_state: false,
    title: '',
    price: '',
    quantity: '1',
    size: '',
    buyer: localStorage.getItem('requestedBy') ?? 'jeff',
    address: types.optional(Address, {}),
    withSignup: false,
  })
  .actions(self => {
    return {
      getStepRoute(step) {
        return url('create-payment-link-page', {
          step,
        });
      },

      initStep(step) {
        self.modalIsVisible = false;
        return self;
      },

      load: flow(function* load() {
        const response = yield makeRequest('create-payment-link-data', self);
        self.address = response.data.address || {};
        self.title = new URLSearchParams(window.location.search).get('title') || '';
        self.hasEnteredTitle = self.title.length > 0;
        self.buyer = localStorage.getItem('requestedBy') ?? null;
      }),

      submit: flow(function* submit() {
        let response;
        if (!self.isSubmitting) {
          self.isSubmitting = true;
          self.error = null;
          self.buyer = localStorage.getItem('requestedBy')

          try {
            response = yield makeRequest(
              'create-payment-link',
              null,
              pick(self, ['title', 'price', 'size', 'quantity', 'address', 'anonymous_id','buyer']),
            );

            localStorage.removeItem('requestedBy');

            const alias = response.data.alias;

            analytics
              .track('Offer Link Created', {
                'Item Price': self.price,
                'Item Name': self.title,
                'Item Quantity': self.quantity || '1',
                'Item Size': self.size,
                'Payment Link': url('checkout-page', { alias }),
                'Location': AppState.currentPage,
                'Requested by': self.buyer || null,
                'Event Initiated by': AppState.currentPage === 'CreateNewPaymentLinkPage' || AppState.currentPage === 'SellerLandingPage'
                  ? 'seller' : 'buyer'
              });


            navigate(url(self.withSignup ? 'seller-payment-link-page' : 'manage-item-page', { alias }));
          } catch (error) {
            self.error = errorResponse(error);
          }

          self.isSubmitting = false;
        }
        return response;
      }),

      setWithSignup(withSignup) {
        self.withSignup = withSignup;
        return self;
      },
      setError(message) {
        self.error = message;
        return self;
      },
      onUpload(image_url) {
        self.primary_image = image_url;
        self.primary_image_state = true;
      },
      openModal() {
        self.modalIsVisible = true;
        return self;
      },
      closeModal() {
        self.modalIsVisible = false;
        return self;
      },

      nextDetail() {
        if (!self.hasEnteredTitle && self.title) {
          self.hasEnteredTitle = true;
        } else if (!self.hasEnteredPrice && self.price && parseInt(self.price) > 0
        && (!self.hasEnteredQuantity && self.quantity && parseInt(self.quantity) > 0)) {
          self.hasEnteredPrice = true;
          self.hasEnteredQuantity = true;
        }
        else if (!self.hasSelectedSize && (self.size !== null || true)) {
          self.hasSelectedSize = true;
        }else if (!self.hasEnteredAddress && self.address) {
          self.hasEnteredAddress = true;
        }
        else {
          self.nextStep();
        }
      },
      setTitle(title) {
        self.title = castEventToValue(title);
      },
      setPrice(price) {
        self.price = castEventToValue(price);
      },
      setQuantity(quantity) {
        self.quantity = castEventToValue(quantity);
      },
      setSize(size) {
        self.size = castEventToValue(size);
        return self;
      },

      addressSaved(savedAddress) {

        if (!savedAddress || self.address.formatted_address !== savedAddress.formatted_address) {
          self.address.setAddress(castToSnapshot(savedAddress));
          self.hasEnteredAddress = true;
        }
        self.modalIsVisible = false;
        return self;

        // self.address.setAddress(getSnapshot(savedAddress));
        // self.hasEnteredAddress = true;
        // self.modalIsVisible = false;
      },
      pushItemToCatalog() {

      },
    };
  });

export default types.compose(
  SteppedPage,
  CreateNewPaymentLinkPageState,
);
